import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

export const componentQuery = createApi({
  baseQuery,
  reducerPath: "componentQueries",
  endpoints: (builder) => ({
    getAllListComponents: builder.query<any, any>({
      query: () => ({
        url: `${formatString(endPoints.component.getAllList)}`,
        method: "GET",
      }),
    }),
    getAllDetailsComponents: builder.query<any, any>({
      query: () => ({
        url: `${formatString(endPoints.component.getAllDetails)}`,
        method: "GET",
      }),
    }),
    getAllPageLayout: builder.query<any, any>({
      query: () => ({
        url: `${formatString(endPoints.component.getAllPageLayout)}`,
        method: "GET",
      }),
    }),
    //This is dummy API, we can remove later
    getAllInventory: builder.query<any, any>({
      query: () => ({
        url: `${formatString(endPoints.generic.getAll)}`,
        method: "GET",
      }),
    }),
    selectInventory: builder.query<any, any>({
      query: () => ({
        url: `${formatString(endPoints.generic.select)}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLazyGetAllDetailsComponentsQuery,
  useLazyGetAllListComponentsQuery,
  useLazyGetAllPageLayoutQuery,
  useGetAllInventoryQuery,
  useSelectInventoryQuery,
} = componentQuery;
